import React from 'react'
import {css} from '@emotion/react'

import GenericTabPanel from '../../../../components/layouts/TwoPanelLayout/GenericTabPanel'
import TabsPanel from '../../../../components/layouts/TwoPanelLayout/TabsPanel'


export default function ControlDetailPanelMobileLayout({controlLabel, control, detailLabel, overrideActiveTab, children}) {
  const styles = {
    root: css`
      height: 100%;
      display: flex;
      gap: 8px;
      position: relative;

      > * {
        flex: 1;
        width: 0; // 確保兩邊同寬
      }
    `,
  }

  return (
    <div css={styles.root}>
      <TabsPanel overrideActiveTab={overrideActiveTab}>
        <GenericTabPanel
          tabKey="left-panel"
          tabLabel={controlLabel}
          content={control}
        />
        <GenericTabPanel
          tabKey="right-panel"
          tabLabel={detailLabel}
          content={children}
        />
      </TabsPanel>
    </div>
  )
}
